import { createStore } from "jotai";

/**
 * Store jotai único de la app (el mismo que pasa el `<Provider>` en Root.tsx).
 * Vive en su propio módulo para poder leer/escribir atoms FUERA de React —
 * p. ej. el loader de go scenes que corre tras el login — sin duplicar stores
 * ni arriesgar ciclos de import (Root → Routes → atoms).
 */
export const store = createStore();
